export const state = () => ({
  uploadedKey: null,
  uploadedStamp: null,
  stampPassword: null
})

export const getters = {
  uploadedKey: state => state.uploadedKey,
  uploadedStamp: state => state.uploadedStamp,
  stampPassword: state => state.stampPassword
}

export const mutations = {
  SET_EDS_KEY(state, keyData) {
    state.uploadedKey = keyData
  },
  SET_EDS_STAMP(state, stampData) {
    state.uploadedStamp = stampData
  },
  SET_STAMP_PASSWORD(state, password) {
    state.stampPassword = password
  }
}
